import { render, staticRenderFns } from "./ObiDropdown.vue?vue&type=template&id=340c3b6c&scoped=true&"
import script from "./ObiDropdown.vue?vue&type=script&lang=js&"
export * from "./ObiDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ObiDropdown.vue?vue&type=style&index=0&id=340c3b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340c3b6c",
  null
  
)

export default component.exports